import { notification } from "antd"
import axios from "axios"

const apiHandler = axios.create({
    timeout: 1000 * 10,
})

apiHandler.interceptors.request.use(config => {
    const TOKEN = localStorage.getItem('TOKEN')
    if (TOKEN) config.headers.Authorization = `Bearer ${TOKEN}`
    config.headers['Content-Type'] = 'application/json'
    return config
})

export const resultParser = result => {
    if (result.status === 200) {
        let { data: res } = result
        if (res.code !== 200) {
            // 用户信息过期401 无权限402 路径错误404
            notification.error({
                description: res.message
            })
            if (res.code === 401) setTimeout(() => {
                window.location.href = '/9165/login'
                localStorage.removeItem('USER_INFO')
                localStorage.removeItem('TOKEN')
            }, 2000);
            if (res.code === 402) setTimeout(() => {
                window.location.href = '/9165/login'
            }, 2000);
        }
        return res
    } else {
        // axios err
        notification.error({
            description: '网络错误，请联系管理员'
        })
        return result.data
    }
}

export default apiHandler
